import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import {  get } from "@utils/axios_api";
import { Select, Input, Checkbox } from "@components/form";
import { getOptions  } from '@utils/CommonCodes';

function MemberSearch({ defaultValues, onSearch, onReset }) {

  const { data:companyList } = useQuery({
    queryKey: ["adminSearchCompanyList"],
    queryFn: async () => {
      const response = await get("/admin/mem/companyList");
      return response;
    },
  });

  const methods = useForm({
    defaultValues,
  });
  const { handleSubmit, reset } = methods;

  const handleReset = () => {
    if (!window.confirm('조회 조건을 초기화 하시겠습니까?')) return;  
    reset({
      comdCode   : "",
      bizRegNo   : "",
      searchCnd  : "",
      searchWrd  : "",
      checkVal   : false,
    });
    onReset && onReset();
  };



  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSearch)}>
        <div className="search-wrap">
          <div className="search-row">
            <div className="search-item">
            <label>상태</label>
            <Select
                name="comdCode"
                options={getOptions("MEMBER_STATUS")}
                valueKey="comdCode"  
                labelKey="comdName"
                defaultOption="전체" 
                className="input-select"
            />
            <label>업체</label>
            <Select
                name="bizRegNo"
                options={companyList?.result}
                valueKey="bizRegNo"  
                labelKey="companyNm"
                defaultOption="전체" 
                className="input-select"
            />

            <label style={{ marginLeft: "10px" }}>조회조건</label>
              <Select
                name="searchCnd"
                options={[
                  { key: "0", name: "아이디" },
                  { key: "1", name: "이름" },
                ]}
                defaultOption="선택"
                className="input-select"
              />
              <Input
                name="searchWrd"
                placeholder="검색어를 입력하세요"
                className="input-search"
                style={{ width: "250px" }}
              />
            <label style={{ marginLeft: "10px" }}>관리자 조회</label>
            <Checkbox 
              name="checkVal"

            />
            </div>
            <div className="search-btn-container">
              <button type="submit" className="btn-search">조회</button>
              <button type="button" className="btn-reset" onClick={handleReset}>초기화</button>
            </div>
          </div>
        </div>
      </form>
    </FormProvider>
  );
}

export default MemberSearch;
